const currencyCode = 'PHP';
const locale = 'en-PH';

const formatter = new Intl.NumberFormat(locale, {
  style: 'currency',
  currency: currencyCode,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Site-wide money display (Philippine peso). */
export function formatCurrency(value: number): string {
  return formatter.format(Number(value));
}

/** Shorter labels for large dashboard figures (still PHP). */
export function formatCurrencyCompact(v?: number): string {
  const n = v ?? 0;
  if (n >= 1_000_000) return `₱${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `₱${Math.round(n).toLocaleString(locale)}`;
  return formatCurrency(n);
}
